import alwaysEmptyString from 'utils/functions/nullary/alwaysEmptyString.util';
import isFn from 'utils/predicates/function/isFn.util';

const fromAnyToUmsgFn = (value) => {
  if (isFn(value)) return value;
  if (isFn(value?.fn)) return value?.fn;

  return alwaysEmptyString;
};

export default fromAnyToUmsgFn;
